import { render } from "./AddJob.vue?vue&type=template&id=45d3b754&scoped=true"
import script from "./AddJob.vue?vue&type=script&lang=js"
export * from "./AddJob.vue?vue&type=script&lang=js"

import "./AddJob.vue?vue&type=style&index=0&id=45d3b754&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d3b754"]])

export default __exports__